module.exports = __webpack_public_path__ + "img/IMG_1024_L_BlackMatted.156de21a.jpg";